import { getBaseUrl } from '../utils/Utils'
import { AccessToken } from '../types'
import BaseService from './BaseService'

import {
  SERVICE_USERS_DELETE_CONNECTED_ACCOUNT,
  SERVICE_USERS_GET_CONNECTED_ACCOUNTS,
  SERVICE_USERS_GET_GOOGLE_TOKEN
} from './Endpoint'


class UserConnectionService extends BaseService {
  async getAll({ accessToken }: AccessToken): Promise<any> {
    const url = `${getBaseUrl()}${SERVICE_USERS_GET_CONNECTED_ACCOUNTS}`;
    const response = await this.post(url, {}, accessToken);
    return response.data as string;
  }

  async addAccountToDatabase( { accessToken, params }): Promise<any> {
    const url = `${getBaseUrl()}${SERVICE_USERS_GET_GOOGLE_TOKEN}`;
    const { code, redirectUri } = params;
    const response = await this.post(url, { ...params}, accessToken);
    return response.data as string;
  }

  async deleteAccount({ accessToken }: AccessToken, account_id: string): Promise<any> {
    const url = `${getBaseUrl()}${SERVICE_USERS_DELETE_CONNECTED_ACCOUNT}`;
    const response = await this.post(url, { id: account_id }, accessToken);
    return response.data as string;
  }
}

export const userConnectionService = new UserConnectionService();